// extracted by mini-css-extract-plugin
export var buttons = "_bk-0";
export var buttonsActive = "_bk-h";
export var cancelConfirm = "_bk-1";
export var closeButton = "_bk-2";
export var column = "_bk-3";
export var container = "_bk-4";
export var detailHeader = "_bk-6";
export var detailTitle = "_bk-7";
export var detailsContent = "_bk-5";
export var header = "_bk-8";
export var headerWithClose = "_bk-9";
export var icon = "_bk-a";
export var infoIcon = "_bk-c";
export var informationContainer = "_bk-b";
export var sideDrawer = "_bk-d";
export var sideDrawerOpen = "_bk-e";
export var stickyFooter = "_bk-f";
export var typeOption = "_bk-g";